import { motion } from "framer-motion";
import { CHECKOUT_URL, PRICE_LABEL } from "../config/pricing";
import { track, EVENTS } from "../lib/analytics";

const LINKS = [
  { label: "Demo", href: "#demo" },
  { label: "Inside", href: "#inside" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export function Nav() {
  const onBuy = () => {
    track(EVENTS.CHECKOUT_STARTED, { source: "nav" });
    window.location.href = CHECKOUT_URL;
  };

  return (
    <motion.header
      initial={{ y: -56, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
      className="fixed inset-x-0 top-0 z-50 border-b border-line/80 bg-paper/80 backdrop-blur-md"
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <a
          href="#top"
          data-testid="header-brand-logo"
          className="font-display text-xl tracking-tight text-ink"
        >
          SayIt<span className="text-brand">.</span>
        </a>
        <nav className="hidden items-center gap-8 md:flex" aria-label="Primary">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-smoke transition-colors duration-200 hover:text-ink"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <button
          type="button"
          data-testid="header-buy-button"
          onClick={onBuy}
          className="rounded-full bg-ink px-4 py-2 text-sm font-medium text-paper transition-colors duration-200 hover:bg-black"
        >
          Get SayIt — {PRICE_LABEL}
        </button>
      </div>
    </motion.header>
  );
}
